var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('MenuStudent'),_c('div',{staticClass:"student-container"},[_c('a-layout',[_c('a-layout-sider',[_c('SideMenuStudent')],1),_c('a-layout-content',[_c('a-card',{attrs:{"bordered":false}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }